import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Section } from 'src/app/core/models/DigitalKit';
import { NgOptimizedImage } from '@angular/common';

@Component({
  selector: 'app-who-we-are',
  templateUrl: './who-we-are.component.html',
  styleUrls: ['./who-we-are.component.css'],
  standalone: false
})

export class WhoWeAreComponent implements OnInit {

  constructor(private titleService: Title) { }

  ngOnInit() {
    this.titleService.setTitle('Zeeker Solutions | ¿Quiénes somos?');
  }

  cards: Section[] = [
    {
      title: 'Especialistas',
      description: 'Nuestro equipo está formado por consultores y especialistas en UX/UI, marketing digital, transformación digital y estrategia de negocio para apoyar al cliente en todos sus ámbitos.',
      icon: 'assets/svg/team.svg'
    },
    {
      title: 'Dinámicos',
      description: 'Bajo una metodología ágil utilizando sprints y conseguimos ejecutar los proyectos con mayor rapidez y efectividad.',
      icon: 'assets/svg/dynamic.svg'
    },
    {
      title: 'Digitales',
      description: 'La visión digital está presente en todos los proyectos que realizamos para brindar al cliente una solución 100% de calidad.',
      icon: 'assets/svg/interactive.svg'
    },
  ]

  funcionalities: Section[] = [
    {
      title: 'Cálculo de procesos y estructura actual de la empresa',
      description: 'Mapeo de procesos para determinar el punto de partida y la situación actual.',
      icon: 'assets/img/calculo_procesos.webp'
    },
    {
      title: 'Diseño de la solución con el cliente',
      description: 'Definimos la hoja de ruta digital y las soluciones más adecuadas para cada caso. La visión y objetivos del cliente son el centro de cada decisión.',
      icon: 'assets/img/diseno_plataforma.webp'
    },
    {
      title: 'Implementación y adopción',
      description: 'Acompañamos al cliente en la implantación de las soluciones definidas, asegurando la correcta adopción y resultados medibles.',
      icon: 'assets/img/construccion.webp'
    },
    {
      title: 'Evaluación y monitoreo',
      description: 'Determinan KPI´s, reports y demás métricas para poder controlar el proceso cumpliendo los objetivos establecidos.',
      icon: 'assets/img/evaluacion_monitoreo.webp'
    }
  ]

}
